import { Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { memo, useState } from "react";
import { TbUser } from "react-icons/tb";

import CommonPopup from "@/components/CommonPopup";
import { PassengerCard } from "@/components/PassengerCard";
import { TableHeader } from "@/components/TableHeader";
import { Size } from "@/hooks/useWindowDimensions";
import { PassengerTypes } from "@/types/global";
import { IPlanPassenger } from "@/types/tasks.types";

import PassengerInfoPopup from "../../pages/Plannn/components/table/PassengerInfoPopup";

export const PassengerColumnCell = memo(
    ({
        row,
        value,
        raw,
        avatarVariant,
        passengerClassName,
        avatarSize,
        showDetails = true,
        withoutClipBoard,
    }: {
        avatarVariant?: "circular" | "square" | "rounded";
        raw: boolean;
        row: Pick<IPlanPassenger<"api">, "status" | "id" | "passengerType"> & { cancelled?: boolean };
        value: string;
        passengerClassName?: string;
        avatarSize?: number;
        showDetails?: boolean;
        withoutClipBoard?: boolean;
    }) => {
        {
            const [showDetailPopup, setShowDetailPopup] = useState(false);
            const isCustom = row.passengerType === PassengerTypes.MANUAL;
            const handleDetailPopup = (val?: boolean) => setShowDetailPopup(val ?? !showDetailPopup);

            return (
                <>
                    {showDetails ? (
                        <Tooltip title="Yolcu detayını görmek için tıklayınız">
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    if (isCustom) return;
                                    handleDetailPopup(true);
                                }}
                                className={`flex items-center h-full gap-1 active:scale-95  hover:scale-105 duration-200 hover:underline"}`}
                            >
                                <PassengerCard
                                    avatarSize={avatarSize}
                                    avatarVariant={avatarVariant}
                                    className={passengerClassName || "gap-1 text-xs"}
                                    name={value}
                                    isCustom={isCustom}
                                    cancelled={row.cancelled}
                                />
                            </button>
                        </Tooltip>
                    ) : (
                        <PassengerCard
                            avatarSize={avatarSize}
                            avatarVariant={avatarVariant}
                            className={passengerClassName || "gap-1 text-xs"}
                            name={value}
                            isCustom={isCustom}
                            cancelled={row.cancelled}
                            withoutClipBoard={withoutClipBoard}
                        />
                    )}

                    <CommonPopup
                        title={"Yolcu Bilgileri"}
                        onClose={() => handleDetailPopup(false)}
                        size="md"
                        open={showDetailPopup}
                    >
                        <PassengerInfoPopup raw={raw} passenger={row} closePopup={() => handleDetailPopup(false)} />
                    </CommonPopup>
                </>
            );
        }
    }
);
export const PassengerColumn = ({
    size,
    t,
    raw,
    showDetails = true,
}: {
    raw: boolean;
    size: Size;
    t: TFunction;
    showDetails?: boolean;
}): GridColDef<IPlanPassenger<"api"> & { patientName?: string }> => {
    return {
        field: "name",
        headerName: t("name"),
        minWidth: size.md ? 230 : 135,
        maxWidth: 250,
        flex: 1,
        valueGetter: (_val, row) => row.name || row.patientName || " ",
        renderHeader: (params) => <TableHeader Component={TbUser} title={params.colDef.headerName!} />,
        renderCell: ({ value, row }) => (
            <PassengerColumnCell raw={raw} row={row} value={value} showDetails={showDetails} />
        ),
    };
};
